import {CloseOutlined} from '@ant-design/icons';

import {IconButton} from '../../ui/icon-button/IconButton';

export type ModalHeaderProps = {
  title: string;
  titleId: string;
  onClose?: () => void;
  showCloseButton: boolean;
};

export function ModalHeader({title, titleId, onClose, showCloseButton}: ModalHeaderProps) {
  return (
    <div className="flex h-14 flex-row items-center justify-between border-b border-gray-03 bg-white pe-0 ps-4 text-base font-medium text-gray-08">
      <span id={titleId} className="text-base font-medium text-gray-10">
        {title}
      </span>
      {showCloseButton ? (
        <IconButton
          aria-label="بستن"
          size="md"
          disableHover
          onClick={onClose}
          className="h-full w-12 shrink-0"
        >
          <CloseOutlined aria-hidden />
        </IconButton>
      ) : null}
    </div>
  );
}
